<template>
  <div class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">ご利用ガイド</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="guide_section">
            <div class="guide_msg">
              HAKOTANは、1mm単位でサイズオーダーできる収納家具を簡単にオーダーいただけます。
              ご購入のご案内として、採寸方法から商品のカスタマイズ、ご注文完了までの流れをご確認ください。
            </div>
            <div class="guide_area">
              <div class="guide_title">購入までの流れ</div>
              <div class="guide_flow">
                <div class="guide_sp_flow">
                  <div class="guide_sp_step">
                    <div class="guide_flow_step">Step 1</div>
                    <div class="guide_step_item">設置場所を採寸</div>
                  </div>
                  <div>
                    <div class="guide_flow_item">
                      <div class="guide_flow_icon">
                        <img :src="getImage('guide/icon_measure.png')">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="guide_flow_line sp_hide"></div>
                <div class="guide_sp_flow">
                  <div class="guide_sp_step">
                    <div class="guide_flow_step">Step 2</div>
                    <div class="guide_step_item">カスタマイズ</div>
                  </div>
                  <div>
                    <div class="guide_flow_item">
                      <div class="guide_flow_icon">
                        <img :src="getImage('guide/icon_customize.png')">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="guide_flow_line sp_hide"></div>
                <div class="guide_sp_flow">
                  <div class="guide_sp_step">
                    <div class="guide_flow_step">Step 3</div>
                    <div class="guide_step_item">価格を確認</div>
                  </div>
                  <div>
                    <div class="guide_flow_item">
                      <div class="guide_flow_icon">
                        <img :src="getImage('guide/icon_price.png')">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="guide_flow_line sp_hide"></div>
                <div class="guide_sp_flow">
                  <div class="guide_sp_step">
                    <div class="guide_flow_step">Step 4</div>
                    <div class="guide_step_item">注文完了</div>
                  </div>
                  <div>
                    <div class="guide_flow_item">
                      <div class="guide_flow_icon">
                        <img :src="getImage('guide/icon_completed.png')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div>
              <div class="guide_main">
                <div class="guide">
                  <div class="guide_step">Step1</div>
                  <div class="guide_line line_hight1">
                    <div class="line_area1"></div>
                    <div class="line_area2"></div>
                  </div>
                </div>
                <div class="guide_step_msg">
                  <div class="step_title">設置場所を採寸</div>
                  <div class="step_text">① 採寸の準備</div>
                  <div class="step_msg step_space1">
                    採寸をするにはメジャー準備してください。 また、採寸する際は、垂直・水平に測る必要があります。
                    二人以上での採寸で、より正確に測定ができます。
                  </div>
                  <div class="step_text">② 設置場所を測る</div>
                  <div class="step_msg step_space2">
                    壁から壁まで、または天井から床まで、ピッタリと収まるサイズでオーダーしたい場合は、設置場所の幅・高さ・奥行きを採寸してください。
                    壁、床は歪んでいる場合がありますので、最も短い寸法を割り出すために複数箇所を採寸してください。
                    巾木・コンセント．火災報知器などがある場合は、その内側から採寸してください。
                  </div>
                  <div class="step_area">
                    <div class="step_area_title">
                      <div></div>
                      <div>幅を測る</div>
                    </div>
                    <div class="step_area_msg">
                      設置場所の上下2カ所以上を水平に測り最も短い寸法を実寸とします。巾木がある場合は、その内側から採寸してください。
                      （例）①245㎜ ②244㎜ ③246㎜ → 実寸は244㎜
                    </div>
                    <div class="step_item_area">
                      <div class="area_item">
                        <div class="area_item_title">カウンター下など</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_width_1.png')">
                        </div>
                        <div class="area_item_msg">3箇所採寸して最も短い寸法を実寸とします。</div>
                      </div>
                      <div div class="area_item">
                        <div class="area_item_title">両サイドが挟まれている場合</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_width_2.png')">
                        </div>
                        <div class="area_item_msg">より正確な数値を確認するため上下の計4箇所を採寸しましょう。</div>
                      </div>
                      <div div class="area_item">
                        <div class="area_item_title">壁面など</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_width_3.png')">
                        </div>
                        <div class="area_item_msg">3箇所以上を採寸しましょう。 最も小さい寸法を実寸とします。</div>
                      </div>
                    </div>
                  </div>
                  <div class="step_area">
                    <div class="step_area_title">
                      <div></div>
                      <div>高さを測る</div>
                    </div>
                    <div class="step_area_msg">
                      設置場所の左右2カ所以上を垂直に測り最も短い寸法を実寸とします。火災報知器などがある場合は、その内側から採寸してください。
                      （例）①156㎜ ②155㎜ ③154㎜ → 実寸は154㎜
                    </div>
                    <div class="step_item_area">
                      <div class="area_item">
                        <div class="area_item_title">カウンター下など</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_height_1.png')">
                        </div>
                        <div class="area_item_msg">6箇所採寸して最も短い寸法を実寸とします。</div>
                      </div>
                      <div class="area_item">
                        <div class="area_item_title">壁面など</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_height_2.png')">
                        </div>
                        <div class="area_item_msg">3箇所以上を採寸しましょう。 最も小さい寸法を実寸とします。</div>
                      </div>
                      <div class="area_item">
                        <div class="area_item_title">窓下</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_height_3.png')">
                        </div>
                        <div class="area_item_msg">2箇所以上を採寸しましょう。 最も小さい寸法を実寸とします。</div>
                      </div>
                    </div>
                  </div>
                  <div class="step_area_depth">
                    <div class="step_sub">
                      <div>
                        <div class="step_area_title">
                          <div></div>
                          <div>奥行を測る</div>
                        </div>
                        <div class="step_area_msg">
                          設置場所の上下2カ所以上を水平に測り最も短い寸法を実寸とします。巾木がある場合は、その内側から採寸してください。
                          （例）①102㎜ ②100㎜ ③101㎜ → 実寸は100㎜
                        </div>
                      </div>
                      <div class="area_item">
                        <div class="area_item_title">カウンター下など</div>
                        <div class="area_item_img">
                          <img :src="getImage('guide/guide_1-2_depth_1.png')">
                        </div>
                        <div class="area_item_msg">6箇所採寸して最も短い寸法を実寸とします。</div>
                      </div>
                    </div>
                  </div>
                  <div class="step_area_size">
                    <div>
                      <div class="step_text">③ 家具のサイズを決める</div>
                      <div class="step_msg step_size_msg">
                        家具のサイズは、設置場所の実寸よりも幅、高さ、奥行き方向にそれぞれ10mm以上小さいサイズに設定してください。<br>
                        設置場所の測定値の最も短い寸法を基準に家具のサイズを決定してください。<br>
                        巾木や火災報知器がある場合は、その内側からの寸法となります。扉などがある商品の場合、開いたときに照明、
                        火災報知器などに当たらない寸法に設定してください。
                      </div>
                    </div>
                    <div>
                      <img :src="getImage('guide/guide_1-3_1.png')">
                    </div>
                  </div>
                  <div class="step_special">
                    <div class="special_line"></div>
                    <div class="special_title">壁に固定する必要がある家具の場合</div>
                    <div class="special_area">
                      <div class="special_msg">
                        吊戸棚などの、壁に固定する必要がある商品の場合は壁内の「柱」の場所を確認してください。
                        確認の方法は、壁を数カ所ノックして音で確認します。裏に柱がない場所は音が響き、柱がある場所は短く固い音が鳴ります。
                        市販の下地センサーなどを使用することで、 より確実に確認することができます。
                      </div>
                      <div class="special_img">
                        <img :src="getImage('guide/guide_1-3_2.png')">
                      </div>
                    </div>
                    <div class="special_line"></div>
                  </div>
                </div>
              </div>
              <div class="guide_main">
                <div class="guide">
                  <div class="guide_step">Step2</div>
                  <div class="guide_line line_hight2">
                    <div class="line_area1"></div>
                    <div class="line_area2"></div>
                  </div>
                </div>
                <div class="guide_step_msg">
                  <div class="step_title">カスタマイズ</div>
                  <div class="step_msg">
                    採寸して決定した商品サイズをもとに商品のカスタマイズをします。それぞれカラーを選べるので、
                    お部屋の雰囲気に合わせてお好きな組み合わせをお選びください。
                  </div>
                  <div class="step_custom">
                    <div>
                      <div class="step_text">① 商品を選ぶ</div>
                      <div class="step_msg custin_msg">
                        商品カテゴリページの中から商品を選択してください。商品はそれぞれ、デザイン、扉の有無、
                        選択できるカラー、材料などが異なります。目的にあった商品をお選びください。
                      </div>
                    </div>
                    <div>
                      <img :src="getImage('guide/guide_2-1.png')">
                    </div>
                  </div>
                  <div class="step_custom">
                    <div>
                      <div class="step_text">② サイズ、色を選択</div>
                      <div class="step_msg custin_msg">
                        商品のカスタマイズページにて、ご希望の商品サイズ・カラーを入力・選択してください。
                        サイズは１ミリ単位でご指定いただけます。商品によってカスタマイズ可能なサイズが異なります。
                        お届け先の郵便番号をご入力することで、配送料金が計算されます。
                      </div>
                    </div>
                    <div>
                      <img :src="getImage('guide/guide_2-2.png')">
                    </div>
                  </div>
                  <div class="step_custom">
                    <div>
                      <div class="step_text">③ 組立設置サービスを選択</div>
                      <div class="step_msg custin_msg">
                        組立設置をプロの業者に依頼することもできます。ご依頼される場合は「組立設置サービスの選択」にて
                        「あり」を選択してください。
                      </div>
                    </div>
                    <div>
                      <img :src="getImage('guide/guide_2-3.png')">
                    </div>
                  </div>
                </div>
              </div>
              <div class="guide_main">
                <div class="guide">
                  <div class="guide_step">Step3</div>
                  <div class="guide_line line_hight3">
                    <div class="line_area1"></div>
                    <div class="line_area2"></div>
                  </div>
                </div>
                <div class="guide_step_msg">
                  <div class="step_title">価格を確認</div>
                  <div class="step_msg">
                    ご選択いただいたサイズ・色・配送先情報により、お見積もり金額が計算されます。
                  </div>
                  <div class="step_price">
                    <div>
                      <div class="step_text">① 価格、サイズ、色を確認</div>
                      <div class="step_msg price_msg">
                        カスタマイズが終了したら、「金額・商品図面を確認する」ボタンをクリックすると、
                        カスタマイズされた商品の価格・図面が表示されます。
                        ご確認いただき問題がなければ「カートに追加」をクリックしてください。カートに追加されます。
                      </div>
                    </div>
                    <div>
                      <img :src="getImage('guide/guide_3-1.png')">
                    </div>
                  </div>
                  <div class="step_price_sub">
                    <div class="step_text">② 搬入経路の寸法を確認する</div>
                    <div class="step_msg">
                      搬入の際に、玄関・室内ドアや階段の幅、マンションのエレベーターのスペースが理由で、
                      家具を運べないことがあります。見積もり金額の確認画面に梱包サイズを表示しておりますので、
                      不安な場所は必ず計測ください。
                    </div>
                    <div class="step_msg step_route" @click="onRouteConfirm()"><a>搬入経路のご確認</a></div>
                  </div>
                  <div class="step_price">
                    <div>
                      <div class="step_text">③ 注文を確定する</div>
                      <div class="step_msg price_msg">
                        搬入経路の問題がないことを確認したら、カート画面の「ご購入手続き」ボタンをクリックしてください。
                        お届け先情報や、決済情報の入力をして注文を確定してください。
                        なお、HAKOTANはお客様のオーダーに合わせて一つひとつ製造する商品なので、
                        キャンセルやご注文後の変更はお受けできません。ご了承ください。
                      </div>
                    </div>
                    <div>
                      <img :src="getImage('guide/guide_3-3.png')">
                    </div>
                  </div>
                </div>
              </div>
              <div class="guide_main">
                <div class="guide">
                  <div class="guide_step step_end">Step4</div>
                </div>
                <div class="guide_step_msg">
                  <div class="step_title step_end">注文完了</div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'dcPaymentGuide'
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getYasumokuResource(image)
    },
    onRouteConfirm: function () {
      this.$router.push({
        name: 'DcPaymentGuideConfirm'
      })
    }
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-guide.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcPaymentGuide.vue